import { useState } from "react";

import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";

type PopOutBoxProps = {
  classes?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  position?: "right" | "left"; // new prop
};

export default function PopOutBox({ classes = "", children, icon = <QuestionMarkCircleIcon className="h-5 w-5 text-gray-600" />, position = "right" }: PopOutBoxProps) {
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  return (
    <div
      className="relative cursor-help"
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
    >
      {icon}
      {isHovering && (
        <div className={`p-1 absolute z-60 bg-white border rounded-md ${position === "left" ? "right-full" : "left-full"} ${classes}`}>
          {children}
        </div>
      )}
    </div>
  )
}